import { CardElement, CardNumberElement, CardExpiryElement, CardCvcElement, ElementsConsumer } from '@stripe/react-stripe-js';
import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { attachPaymentMethodToCustomer, openStripePaymentMethodModal } from '../../../store/actions/paymentActions';
import STRIPE_LOGO from '../../../assets/svgs/stripe.svg'

const countriesNames = ["Afghanistan", "Åland Islands", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, The Democratic Republic of The", "Cook Islands", "Costa Rica", "Cote D'ivoire", "Croatia", "Cuba", "Cyprus", "Czechia", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-bissau", "Guyana", "Haiti", "Heard Island and Mcdonald Islands", "Holy See (Vatican City State)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran, Islamic Republic of", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libyan Arab Jamahiriya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Macedonia, The Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestinian Territory, Occupied", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russian Federation", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and The Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and The South Sandwich Islands", "Spain", "Sri Lanka", "Sudan", "Suriname", "Svalbard and Jan Mayen", "Swaziland", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "United States Minor Outlying Islands", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Viet Nam", "Virgin Islands, British", "Virgin Islands, U.S.", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"];
const countriesIsos = ['AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CN', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'CR', 'CI', 'HR', 'CU', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF', 'PF', 'TF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GG', 'GN', 'GW', 'GY', 'HT', 'HM', 'VA', 'HN', 'HK', 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IM', 'IL', 'IT', 'JM', 'JP', 'JE', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR', 'KW', 'KG', 'LA', 'LV', 'LB', 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MK', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'MU', 'YT', 'MX', 'FM', 'MD', 'MC', 'MN', 'ME', 'MS', 'MA', 'MZ', 'MM', 'NA', 'NR', 'NP', 'NL', 'AN', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'MP', 'NO', 'OM', 'PK', 'PW', 'PS', 'PA', 'PG', 'PY', 'PE', 'PH', 'PN', 'PL', 'PT', 'PR', 'QA', 'RE', 'RO', 'RU', 'RW', 'SH', 'KN', 'LC', 'PM', 'VC', 'WS', 'SM', 'ST', 'SA', 'SN', 'RS', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB', 'SO', 'ZA', 'GS', 'ES', 'LK', 'SD', 'SR', 'SJ', 'SZ', 'SE', 'CH', 'SY', 'TW', 'TJ', 'TZ', 'TH', 'TL', 'TG', 'TK', 'TO', 'TT', 'TN', 'TR', 'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'GB', 'US', 'UM', 'UY', 'UZ', 'VU', 'VE', 'VN', 'VG', 'VI', 'WF', 'EH', 'YE', 'ZM', 'ZW'];

class CheckoutForm extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            countryIsoSelected: "GB",

            errorMessage: "",

            accountTitle: "",
            phone: "",
            email: "",

            city: "",
            addressLine1: "",
            addressLine2: "",
            postal: ""
        }
    }

    updateSelectedCountry = (e) => {
        const countryIsoSelected = countriesIsos[e.target.selectedIndex];
        this.setState({
            countryIsoSelected,
        }, () => console.log(this.state.countryIsoSelected))
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = async (event) => {
        console.log("CARD ATTACH SUBMIT")
        const { uid } = this.props.userData;
        const { coid } = this.props.companyData;
        const { stripeSetupIntent, paymentMessage } = this.props.payment;
        const { accountTitle, phone, email, countryIsoSelected, city, addressLine1, addressLine2, postal } = this.state;

        // Block native form submission.
        event.preventDefault();

        const { stripe, elements } = this.props;

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }

        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        this.setState({
            errorMessage: ""
        }, async () => {
            const { error, setupIntent } = await stripe.confirmCardSetup(`${stripeSetupIntent}`, {
                payment_method: {
                    // https://stackoverflow.com/questions/62171886/how-should-i-pass-cardnumberelement-cardexpiryelement-and-cardcvcelement
                    card: elements.getElement(CardNumberElement),
                    billing_details: {
                        address: {
                            city: city,
                            country: countryIsoSelected,
                            line1: addressLine1,
                            line2: addressLine2,
                            postal_code: postal,
                            state: null
                        },
                        email: email,
                        name: accountTitle,
                        phone: phone,
                    },
                }
            });

            if (error) {
                // Display result.error.message in your UI.
                console.log('[error]', error);
                this.setState({
                    errorMessage: "Authorization has failed. Please try again."
                })
            } else {
                // The setup has succeeded. Display a success message and send
                // setupIntent.payment_method to your server to save the
                // card to a Customer
                const paymentMethodId = setupIntent.payment_method;
                this.props.attachPaymentMethodToCustomer(coid, paymentMethodId);
            }
        })
    };

    render() {
        const formCheckStyle = {
            fontSize: "12px",
        };

        const formLabelStyle = {
            fontSize: "12px",
            fontWeight: "bold",
        };

        const CARD_OPTIONS = {
            iconStyle: "solid",
            style: {
                base: {
                    iconColor: "#141414",
                    color: "#141414",
                    fontWeight: 500,
                    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
                    fontSize: "16px",
                    fontSmoothing: "antialiased",
                    ":-webkit-autofill": {
                        color: "#141414"
                    },
                    "::placeholder": {
                        color: "grey"
                    }
                },
                invalid: {
                    iconColor: "#141414",
                    color: "#a20000"
                }
            }
        };

        const { stripe, payment } = this.props;
        const { isPaymentMethodActed, isPaymentMethodActing, paymentMessage } = payment;
        const relevantComponent = !isPaymentMethodActed ? !isPaymentMethodActing ? <button className="btn btn-dark btn-sm" style={{ borderRadius: '9px' }} type="submit" disabled={!stripe}>Add this card</button> : <button className="btn btn-dark btn-sm" type="button" disabled>
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            &nbsp; Attaching card
        </button> : <React.Fragment />

        const relevantMessage = <p style={{ color: `${isPaymentMethodActed ? 'black' : 'red'}` }}>{paymentMessage}</p>

        const selectedCountryName = countriesNames[countriesIsos.indexOf(this.state.countryIsoSelected)]

        return (
            <React.Fragment>
                <form onSubmit={this.handleSubmit}>
                    <h5>General details</h5>
                    {/* NAME */}
                    <div className="form-group text-left">
                        <label htmlFor="accountTitle" style={formLabelStyle}>Account name</label>
                        <input type="text" className="form-control" id="accountTitle" onChange={this.handleChange} required />
                    </div>

                    {/* EMAIL */}
                    <div className="form-group text-left">
                        <label htmlFor="email" style={formLabelStyle}>Email</label>
                        <input type="email" className="form-control" id="email" onChange={this.handleChange} required />
                    </div>

                    {/* PHONE */}
                    <div className="form-group text-left">
                        <label htmlFor="phone" style={formLabelStyle}>Phone</label>
                        <input type="tel" className="form-control" id="phone" onChange={this.handleChange} placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" required />
                    </div>
                    <br />

                    <h5>Billing and shipping address</h5>
                    {/* ADDRESS - Country */}
                    <div className="form-group text-left">
                        <label htmlFor="country" style={formLabelStyle}>Selected country</label>
                        <select className="form-control form-control" defaultValue={selectedCountryName} onChange={this.updateSelectedCountry}>
                            {countriesNames.map((e, i) => {
                                return <option key={i} value={e}>{e}</option>
                            })}
                        </select>
                        {/* <input type="text" className="form-control" id="country" placeholder="Hint: GB" value={this.state.countryIsoSelected} required readOnly /> */}
                    </div>

                    {/* ADDRESS - City */}
                    <div className="form-group text-left">
                        <label htmlFor="city" style={formLabelStyle}>City</label>
                        <input type="text" className="form-control" id="city" onChange={this.handleChange} required />
                    </div>

                    {/* ADDRESS - Line 1 */}
                    <div className="form-group text-left">
                        <label htmlFor="addressLine1" style={formLabelStyle}>Address line 1</label>
                        <input type="text" className="form-control" id="addressLine1" onChange={this.handleChange} required />
                    </div>

                    {/* ADDRESS - Line 2 */}
                    <div className="form-group text-left">
                        <label htmlFor="addressLine2" style={formLabelStyle}>Address line 2</label>
                        <input type="text" className="form-control" id="addressLine2" onChange={this.handleChange} />
                    </div>

                    {/* ADDRESS - Postal */}
                    <div className="form-group text-left">
                        <label htmlFor="postal" style={formLabelStyle}>Postal or ZIP code</label>
                        <input type="text" className="form-control" id="postal" onChange={this.handleChange} required />
                    </div>
                    <br />

                    <h5>Card details</h5>
                    {/* CARD */}
                    <div className="form-group text-left">
                        <label htmlFor="card" style={formLabelStyle}>Card number</label>
                        <CardNumberElement options={CARD_OPTIONS} id="card" className="form-control" />
                    </div>
                    <div className="form-group text-left">
                        <label htmlFor="card" style={formLabelStyle}>Card expiry date</label>
                        <CardExpiryElement options={CARD_OPTIONS} id="card-exp" className="form-control" />
                    </div>
                    <div className="form-group text-left">
                        <label htmlFor="card" style={formLabelStyle}>Card CVC number</label>
                        <CardCvcElement options={CARD_OPTIONS} id="card-cvc" className="form-control" />
                    </div>
                    <br />
                    <p style={{ color: 'red' }}>{this.state.errorMessage}</p>
                    {relevantMessage}
                    {relevantComponent}
                </form>

                <br />
                <img src={STRIPE_LOGO} width="100px" />
            </React.Fragment>
        );
    }
}

class CardAttachModal extends Component {

    componentDidMount() {
        const { coid } = this.props.companyData;
        this.props.openStripePaymentMethodModal(coid);
    }

    render() {
        const { modalWidth, modalTitleStyle, modalInfoTextStyle, attachPaymentMethodToCustomer, userData, payment, companyData } = this.props;
        const { stripeSetupIntent, paymentMessage } = payment;

        let relevantComponentBody = <React.Fragment />;
        if (stripeSetupIntent === "") {
            relevantComponentBody = <div className="spinner-border" role="status">
                <span className="sr-only">Please wait while form opens up...</span>
            </div>;
        } else if (stripeSetupIntent === "-1") {
            relevantComponentBody = <p>{paymentMessage}</p>;
        } else {
            relevantComponentBody = <ElementsConsumer>
                {({ elements, stripe }) => (
                    <CheckoutForm elements={elements} stripe={stripe} attachPaymentMethodToCustomer={attachPaymentMethodToCustomer} companyData={companyData} userData={userData} payment={payment} />
                )}
            </ElementsConsumer>;
        }

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModal">
                    <div className="px-3">
                        <p style={modalTitleStyle}>Attach a new card</p>
                        <p style={modalInfoTextStyle}>This is just a card attachment. The card will not be charged yet.</p>
                        <br />
                        {relevantComponentBody}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,

        formLabelStyle: state.appControl.formLabelStyle,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,

        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyData: state.firestore.data.Company,

        payment: state.payment,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        openStripePaymentMethodModal: (coid) => dispatch(openStripePaymentMethodModal(coid)),
        attachPaymentMethodToCustomer: (coid, paymentMethodId) => dispatch(attachPaymentMethodToCustomer(coid, paymentMethodId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CardAttachModal);